export default __webpack_public_path__ + "static/media/video.b66b9fd1.svg";